import { render, staticRenderFns } from "./TrainPadDayTongJi.vue?vue&type=template&id=5168e0cf&scoped=true&"
import script from "./TrainPadDayTongJi.vue?vue&type=script&lang=js&"
export * from "./TrainPadDayTongJi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168e0cf",
  null
  
)

export default component.exports